import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCloseOutline({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="m7.694 6 3.952-3.952c.473-.473.47-1.228.002-1.696a1.196 1.196 0 0 0-1.696.002L6 4.306 2.048.354A1.196 1.196 0 0 0 .352.352a1.196 1.196 0 0 0 .002 1.696L4.306 6 .354 9.952a1.196 1.196 0 0 0-.002 1.696 1.196 1.196 0 0 0 1.696-.002L6 7.694l3.952 3.952c.473.473 1.228.47 1.696.002a1.196 1.196 0 0 0-.002-1.696L7.694 6z"/>
        </svg>
    );
}

export default IconCloseOutline;

